import { Ellipsis, View } from '@clearkit/icons';
import { CKActionMenu, CKBox, CKButton, CKPopover } from 'clearkit';

import { HomeBannerHeader, HomeBannerHeaderProps } from './HomeBannerHeader';

type HomeBannerMatchRateProps = HomeBannerHeaderProps & {
  generatedAt?: string;
  totalRecords?: number;
  onRefresh?: () => void;
};

export const HomeBannerMatchRate = ({
  generatedAt,
  totalRecords,
  onRefresh,
  ...rest
}: HomeBannerMatchRateProps) => {
  if (!totalRecords || !generatedAt) return null;

  return (
    <HomeBannerHeader {...rest}>
      <HomeBannerHeader.Left>
        <CKBox className="p-2">
          <View className="fill-gradient-br-x" />
        </CKBox>
      </HomeBannerHeader.Left>
      <HomeBannerHeader.Message>
        Your match rate analysis is based on the most recent {totalRecords}{' '}
        leads in your CRM, as of{' '}
        {new Date(generatedAt).toLocaleDateString('en-us', {
          month: 'long',
          day: 'numeric',
          year: 'numeric',
        })}
        .
      </HomeBannerHeader.Message>
      <HomeBannerHeader.Right>
        <CKPopover
          className="grow-0 basis-auto"
          placement="bottom-end"
          popover={
            <CKActionMenu>
              <CKActionMenu.Item onClick={onRefresh}>
                Refresh Data
              </CKActionMenu.Item>
            </CKActionMenu>
          }
        >
          <CKButton>
            <Ellipsis />
          </CKButton>
        </CKPopover>
      </HomeBannerHeader.Right>
    </HomeBannerHeader>
  );
};
